import { endpoint } from "../../../common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from "../../../common/utils/methods/commonMethods/utilityMethod";

export const receiptTypes = [
    { label: 'Receipt', value: 'receipt' },
    { label: 'Refund', value: 'refund' },
]

export const accountTypes = [
    { label: 'CST', value: 'CST' },
    { label: 'DVAT', value: 'DVAT' },
    { label: 'NET', value: 'NET AMOUNT' },
    { label: 'RF', value: 'REFUND CTRL' },
    { label: 'STAX', value: 'ADV SERVICE TAX' },
    { label: 'SBC', value: 'SWATCH BHARAT' },
    { label: 'TUT', value: 'ADV TUITION FEES' },
    { label: 'CGST', value: 'CGST CREDIT' },
    { label: 'IGST', value: 'IGST CREDIT' },
    { label: 'KKC', value: 'KRISHI KALYAN CESS' },
    { label: 'SGST', value: 'SGST CREDIT' },
    { label: 'TOT', value: 'TUITION AFTER CREDIT' },
    { label: 'UGST', value: 'UTGST CREDIT' },
    { label: 'CESS', value: 'CESS @ 1%' }
];

export const indicatorTypes = [
    { label: 'Credit', value: 'credit' },
    { label: 'Debit', value: 'debit' },
]

export const invoiceStatusTypes = [
    { label: 'Before Invoice', value: 'beforeInvoice' },
    { label: 'After Invoice', value: 'afterInvoice' },
]

export const newRow = {
    paymentModeId: '',
    receiptType: '',
    accountType: '',
    indicatorType: '',
    account: '',
    invoiceStatus: '',
    effectiveDate: '',
    status: 'ACTIVE'
};

export const getAccountEntries = async (paymentModeId, filterVal) => {
    const entries = await fetchAllPromisedData(`${endpoint.paymentMode.receiptAccountEntrySetup.accountEntries}?paymentModeId=${paymentModeId}${filterVal ? `&account=${filterVal}` : ''}`);
    const updatedEntries = (entries ?? [])?.map(entry => ({
        ...entry,
        receiptType: receiptTypes?.find(type => type?.value === entry?.receiptType),
        accountType: accountTypes?.find(type => type?.value === entry?.accountType),
        indicatorType: indicatorTypes?.find(type => type?.value === entry?.indicatorType),
        invoiceStatus: invoiceStatusTypes?.find(type => type?.value === entry?.invoiceStatus),
    }))

    return updatedEntries;
}

export const createUpdateAccountEntry = async (rowForm) => {
    const req = updateRequest(rowForm);
    let url = endpoint.paymentMode.receiptAccountEntrySetup.accountEntries;
    let method = "post";

    if (!rowForm?.isNew) {
        url = `${url}/${req?.id}`;
        method = "put";
    }
    return await fetchAllPostPromisedData(url, req, method);
}

